/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbChangementClasseGridDto
 */
export interface FcbChangementClasseGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbChangementClasseGridDto
     */
    idinscription?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbChangementClasseGridDto
     */
    classesource?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbChangementClasseGridDto
     */
    classesourceLabel?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbChangementClasseGridDto
     */
    classecible?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbChangementClasseGridDto
     */
    classecibleLabel?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbChangementClasseGridDto
     */
    datechangement?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbChangementClasseGridDto
     */
    idchangementClasse?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FcbChangementClasseGridDto
     */
    isEditable?: boolean;
}

/**
 * Check if a given object implements the FcbChangementClasseGridDto interface.
 */
export function instanceOfFcbChangementClasseGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbChangementClasseGridDtoFromJSON(json: any): FcbChangementClasseGridDto {
    return FcbChangementClasseGridDtoFromJSONTyped(json, false);
}

export function FcbChangementClasseGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbChangementClasseGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinscription': !exists(json, 'idinscription') ? undefined : json['idinscription'],
        'classesource': !exists(json, 'classesource') ? undefined : json['classesource'],
        'classesourceLabel': !exists(json, 'classesourceLabel') ? undefined : json['classesourceLabel'],
        'classecible': !exists(json, 'classecible') ? undefined : json['classecible'],
        'classecibleLabel': !exists(json, 'classecibleLabel') ? undefined : json['classecibleLabel'],
        'datechangement': !exists(json, 'datechangement') ? undefined : (json['datechangement'] === null ? null : new Date(json['datechangement'])),
        'idchangementClasse': !exists(json, 'idchangementClasse') ? undefined : json['idchangementClasse'],
        'isEditable': !exists(json, 'isEditable') ? undefined : json['isEditable'],
    };
}

export function FcbChangementClasseGridDtoToJSON(value?: FcbChangementClasseGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinscription': value.idinscription,
        'classesource': value.classesource,
        'classesourceLabel': value.classesourceLabel,
        'classecible': value.classecible,
        'classecibleLabel': value.classecibleLabel,
        'datechangement': value.datechangement === undefined ? undefined : (value.datechangement === null ? null : value.datechangement.toISOString()),
        'idchangementClasse': value.idchangementClasse,
        'isEditable': value.isEditable,
    };
}

